import { ThemeType } from './theme';


export const listStylesReset = {
    listStyle: 'none',
    margin: 0,
    padding: 0
};

export const buttonStylesReset = {
    padding: 0,
    fontFamily: 'inherit',
    fontSize: 'inherit',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    border: 0,
    outline: 0,
    cursor: 'pointer'
};

export const fieldsetStylesReset = {
    margin: 0,
    padding: 0,
    border: 0
};

export const inputStylesReset = {
    padding: 0,
    border: 0,
    fontFamily: 'inherit',
    fontSize: 'inherit',
    boxSizing: 'border-box',
    outline: 0
};

export const checkboxReset = {
    width: 0,
    height: 0,
    opacity: 0,
    margin: 0
};

export const tableStylesReset = {
    borderCollapse: 'collapse',
    borderSpacing: 0,
};

export const defaultLinkStyles = (theme: ThemeType) => ({
    color: theme.colors.mainBlue,
    textDecoration: 'none',
    cursor: 'pointer',

    '&:hover': {
        color: theme.colors.hoverBlue
    }
});

export const tooltipLinkStyles = (theme: ThemeType) => ({
    color: theme.colors.mainYellow,
    textDecoration: 'none',

    '&:hover': {
        color: theme.colors.hoverYellow
    }
});
